import { has } from 'lodash';

import validationRules from './validationRules';
import validationMessage from './validationMessages';

export const debounceTimeout = 100;

const validator = (state, event) => {
    let validState;
    let confirmValue = null;
    let value = event.target.value;
    const name = event.target.name;

    const updatedControls = {
        ...state.formControls
    };

    const updatedFormElement = {
        ...updatedControls[name]
    };

    if (name === 'startValue' || name === 'endValue') {
        confirmValue = {
            startValue: (name === 'startValue') ? value : updatedControls['startValue'].value,
            endValue:   (name === 'endValue') ? value : updatedControls['endValue'].value
        };
    }

    if (event.target.type === 'password' && has(updatedControls, 'confirmPassword')) {
        if (name === 'password') {
            confirmValue = updatedControls['confirmPassword'].value;
        } else if (name === 'confirmPassword') {
            confirmValue = updatedControls['password'].value;
        }
    }

    if (event.target.type === 'checkbox') {
        value = event.target.checked;
    }

    if (event.target.name === 'contractorName') {
        value = event.target.value;
    }

    validState = validationRules(value, confirmValue, updatedFormElement.validationRules);
    updatedFormElement.value = value;

    updatedFormElement.touched = true;
    updatedFormElement.valid = validState.isValid;

    if (!validState.isValid) {
        updatedFormElement.message = validationMessage(validState.brokenRule);
    }

    if (event.target.type === 'password' &&
        validState.isValid &&
        has(updatedControls, 'confirmPassword')) {
        if (name === 'password') {
            updatedControls['confirmPassword'].valid = true;
            updatedControls['confirmPassword'].message = '';
        } else if (name === 'confirmPassword') {
            updatedControls['password'].valid = true;
            updatedControls['password'].message = '';
        }
    }

    updatedControls[name] = updatedFormElement;

    let formIsValid = true;
    for (let inputIdentifier in updatedControls) {
        formIsValid = updatedControls[inputIdentifier].valid && formIsValid;
    }

    return {formIsValid, updatedControls};
};

export default validator;
